/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useRef } from "react";

import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Empty, Skeleton } from "antd";

import { faqArticleFetchRequest } from "../../../store/faq/actions";
import { RootState } from "../../../store/root_reducer";

import styles from "./styles.module.scss";

export const FAQArticlePage: React.FC = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation("faq_page");
  const { slug } = useParams<{ slug: string }>();
  const articleRef = useRef<HTMLDivElement>(null);
  const state = useSelector((root: RootState) => root.FAQ);

  useEffect(() => {
    setTimeout(() => {
      articleRef.current && articleRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    dispatch(faqArticleFetchRequest({ slug }));
  }, [dispatch, slug, i18n.language]);

  return (
    <article className={styles.article} ref={articleRef}>
      <Skeleton className={styles.header} title={false} active loading={state.isArticleLoading}>
        <h1 className={styles.header}>{state.article && state.article.title}</h1>
      </Skeleton>
      <div className="ck-content">
        <Skeleton title={false} active loading={state.isArticleLoading} paragraph={{ rows: 20, width: "100%" }}>
          {state.article ? ReactHtmlParser(state.article.content) : <Empty />}
        </Skeleton>
      </div>
    </article>
  );
};
